<app-commissioning-spinner
  [title]="'+SRC_COMMISSIONINGV2.MESSAGE_VERIFYING_DATA' | translate"
  [message]="'+SRC_COMMISSIONINGV2.MESSAGE_VERIFYING_DATA_DESCRIPTION' | translate"
></app-commissioning-spinner>
